import { cn } from "@omni/utils/styles";

import { Dropdown } from "@/components/General/Dropdown/dropdown.component";
import { getLabel } from "@/components/General/LanguageSelector/partials/label.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { Config } from "@/utils/config.utils";

import { DropdownLanguageItem } from "./drownDownLanguageItem.component";

type Props = {
    variant?: "small" | "large";
};

const LanguageDropDownSelector = ({ variant }: Props) => {
    const { t } = useGranite();

    const currentLanguage = Config.languages.find(
        (language) => language.locale === Config.general.locale
    );

    const label = getLabel({
        language: currentLanguage,
        variant: variant,
        t: t
    });

    return (
        <Dropdown
            placement={"bottom"}
            isLabel={true}
        >
            <Dropdown.Toggle
                color="transparent"
                className={cn(
                    "tw:transition-none",
                    "tw:bg-transparent tw:text-black tw:border-none tw:shadow-none",
                    "tw:focus:bg-transparent tw:focus:text-black tw:focus:border-none! tw:focus:ring-0!",
                    "tw:hover:bg-transparent tw:hover:text-black tw:hover:border-none! tw:hover:ring-0!",
                    "tw:active:bg-transparent tw:active:text-black tw:active:border-none! tw:active:ring-0!"
                )}
            >
                <Dropdown.Label>{label}</Dropdown.Label>
                <Dropdown.Caret />
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {Config.languages.map((language) => (
                    <DropdownLanguageItem
                        key={language["language-code"]}
                        language={language}
                        isDisabled={language.locale === Config.general.locale}
                        variant={variant}
                    />
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default LanguageDropDownSelector;
